import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Button,
    Modal,
    IconButton,
    TextareaAutosize
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { takrarPranaliData, takrarPranaliUpdate } from "../utils/axios";
import { ATTACHMENT_URL } from "../utils/api";
import TopBar from "./TopBar";

const TakrarPranaliData = () => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [updatedTakrar, setUpdatedTakrar] = useState("");
    const [updatedFile, setUpdatedFile] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchData();
    }, []);

    // Fetch Data from API
    const fetchData = async () => {
        try {
            const response = await takrarPranaliData();
            setData(response.data?.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Open Edit Modal
    const handleEdit = (row) => {
        setCurrentRow(row);
        setUpdatedTakrar(row.takrar);
        setUpdatedFile(null);
        setError("");
        setOpen(true);
    };

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setUpdatedFile(file);
    };

    // Handle Save Action
    const handleSave = async () => {
        if (!updatedTakrar.trim()) {
            setError("Takrar field is required.");
            return;
        }

        const formData = new FormData();
        formData.append("takrar", updatedTakrar);
        if (updatedFile) {
            formData.append("attachment_file", updatedFile);
        }

        try {
            await takrarPranaliUpdate(formData);
            setOpen(false);
            fetchData(); // Refresh data after update
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    return (
        <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
            <TopBar />
            <Paper sx={{ my: 5, overflowX: "auto" }}>
                <Typography
                    variant="h6"
                    align="center"
                    className="ff_yatra"
                    sx={{ fontSize: "35px", padding: "10px" }}
                >
                    तक्रार प्रणाली
                </Typography>

                {/* Table */}
                <TableContainer sx={{ border: "1px solid #ccc" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {[
                                    "Sr No",
                                    "Reference No",
                                    "Name",
                                    "Email",
                                    "Mobile No",
                                    "Takrar",
                                    "Attachment",
                                    "Action"
                                ].map((header) => (
                                    <TableCell
                                    className="ff_yatra"
                                        key={header}
                                        sx={{
                                            fontSize: "18px",
                                            color: "#333",
                                            textAlign: "center",
                                            padding: "14px",
                                            border: "1px solid #ccc",
                                            background: "#f0f0f0",
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.length > 0 ? (
                                data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{index + 1}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{row.reference_no || "-"}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{row.name}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{row.email}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{row.mobile_no}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>{row.takrar}</TableCell>
                                        <TableCell align="center" className="ff_baloo" sx={{ border: "1px solid #ccc" }}>
                                            {row.attachment_file ? (
                                                <Button
                                                    onClick={() => window.open(`${ATTACHMENT_URL}/${row.attachment_file}`)}
                                                    variant="outlined"
                                                    size="small"
                                                    color="primary"
                                                >
                                                    View Attachment
                                                </Button>
                                            ) : (
                                                "No Attachment"
                                            )}
                                        </TableCell>
                                        <TableCell align="center" sx={{ border: "1px solid #ccc" }}>
                                            <Button onClick={() => handleEdit(row)}>
                                                <EditIcon />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center" sx={{ border: "1px solid #ccc" }}>
                                        No data available
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Edit Modal */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 3,
                        borderRadius: "8px",
                    }}
                >
                    <IconButton
                        onClick={() => setOpen(false)}
                        sx={{ position: "absolute", top: 10, right: 10 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography variant="h6" mb={2}>
                        Update Takrar
                    </Typography>

                    {/* Textarea for Takrar */}
                    <TextareaAutosize
                        minRows={4}
                        placeholder="Enter Takrar"
                        value={updatedTakrar}
                        onChange={(e) => setUpdatedTakrar(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            outline: "none",
                        }}
                    />

                    {/* File Upload */}
                    <input
                        type="file"
                        onChange={handleFileChange}
                        style={{ marginTop: "10px" }}
                    />

                    {error && (
                        <Typography color="error" mt={1}>
                            {error}
                        </Typography>
                    )}

                    {/* Save and Close Buttons */}
                    <Box mt={3} display="flex" justifyContent="space-between">
                        <Button
                            onClick={handleSave}
                            variant="contained"
                            color="primary"
                        >
                            Save
                        </Button>
                        <Button
                            onClick={() => setOpen(false)}
                            variant="outlined"
                            color="secondary"
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default TakrarPranaliData;